module.exports = __webpack_public_path__ + "static/images/containers/EloLeaderboard/components/LeaderboardTable/images/leaderboard-position2.d540189f.png";


//////////////////
// WEBPACK FOOTER
// ./containers/EloLeaderboard/components/LeaderboardTable/images/leaderboard-position2.png
// module id = 3096
// module chunks = 11